export default function applicationId(val: string) {
  if (!val) return '';
  return `${val.substring(0, 3)}-${val.substring(3, 6)}-${val.substring(6)}`;
}
